module.exports = __webpack_public_path__ + "img/as13.af075c93.jpg";